import type { ReferenceArticle } from "../../_shared/reference-articles/types";

export const REFERENCE_ARTICLES: ReferenceArticle[] = [
	{
		title: "Beds24と連携する方法",
		thumbnailUrl: "/assets/site-controller/reference-articles/beds24/settings.jpg",
		url: "https://chillnn.notion.site/beds24-25cfffe15c5780a9b57fca79fb89b38c",
	},
];
